import { MEMBER_STORAGE_KEYS } from '../constants/storageKeys';
import { clearMemberSession } from '../auth/tokenStorage';
import { createApiClient } from './createClient';

/**
 * 前台會員 HTTP 客戶端。
 * 會員身份僅靠 Authorization Token，由後端 BFF 解析，不在 URL/body 暴露 memberId。
 */
const memberRequest = createApiClient({
  storageKeys: MEMBER_STORAGE_KEYS,
  clearSession: clearMemberSession,
  expiredEvent: 'formosa:auth-expired',
});

export default memberRequest;
